export const PRODUCT_CATEGORIES = [
  {
    value: "fiction",
    label: "La Fiction",
    subcategories: [
      "Roman",
      "Policier",
      "Thriller",
      "Science-fiction",
      "Fantasy",
      "Romance",
      "Historique",
      "Aventure",
      "Fantastique",
      "Bande dessinee (BD)",
      "Manga",
      "Roman graphique",
      "Comics",
      "Litterature jeunesse et ado",
      "Albums illustres",
      "Contes",
      "Premieres lectures",
      "Theatre",
      "Poesie",
      "Tragedie",
      "Comedie",
      "Vers libres",
      "Sonnets",
    ],
  },
  {
    value: "non-fiction",
    label: "La Non-Fiction",
    subcategories: [
      "Developpement personnel et bien-etre",
      "Psychologie",
      "Spiritualite",
      "Sante",
      "Affaires et Finances",
      "Sciences humaines et sociales",
      "Histoire",
      "Politique",
      "Philosophie",
      "Sociologie",
      "Sciences, Techniques et Nature",
      "Informatique",
      "Medecine",
      "Cuisine",
      "Jardinage",
      "Biographies, Recits et Essais",
      "Autobiographies",
      "Journaux intimes",
      "Temoignages",
      "Scolaire",
    ],
  },
  {
    value: "reference",
    label: "Les Oeuvres de Reference",
    subcategories: [
      "Dictionnaires",
      "Atlas",
      "Encyclopedies",
    ],
  },
];

export function getProductCategoryLabel(value) {
  return PRODUCT_CATEGORIES.find((category) => category.value === value)?.label || value || "Non classe";
}

export function getProductSubcategories(categoryValue) {
  return PRODUCT_CATEGORIES.find((category) => category.value === categoryValue)?.subcategories || [];
}
